module.exports = __webpack_public_path__ + "img/lazy_pog.b4b8683d.jpg";